import { styled } from '@mui/material'

export const ClientContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})<{
  focused?: boolean
}>(({ theme, focused }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  alignItems: 'center',
  padding: `${theme.spacing(1)}`,
  minHeight: '32px',
  width: '100%',
  borderRadius: theme.display.borderRadiusSmall,
  backgroundColor: focused ? `${theme.colours.primary20}` : `${theme.colours.baseExtraLight}`,
  '&:hover': {
    backgroundColor: `${theme.colours.primary10}`,
    cursor: 'pointer',
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  '&.Mui-focused.Mui-focusVisible': {
    backgroundColor: `${theme.colours.primary20}`,
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}))

export const CaseContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})<{
  focused?: boolean
}>(({ theme, focused }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  alignItems: 'center',
  padding: `${theme.spacing(1)}`,
  minHeight: '32px',
  width: '100%',
  borderRadius: theme.display.borderRadiusSmall,
  backgroundColor: focused ? `${theme.colours.primary20}` : 'white',
  '&:hover': {
    backgroundColor: `${theme.colours.primary10}`,
    cursor: 'pointer',
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  '&.Mui-focused.Mui-focusVisible': {
    backgroundColor: `${theme.colours.primary20}`,
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}))

export const ClientNamesBox = styled('div')(({ theme }) => ({
  color: theme.colours.base,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(14),
  marginRight: theme.spacing(1),
  lineHeight: 1.6,
  overflow: 'auto',
  display: 'flex',
  gap: 4,
  alignItems: 'center',
  "#UserIcon": {
    flexShrink: 0,
  }
}))

export const EmailBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  padding: `0 ${theme.spacing(.5)}`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const PhoneBox = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  padding: `0 ${theme.spacing(.5)}`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const CaseTypeBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'flex',
  gap: 4,
}))

export const CaseStatusBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const PostcodeBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  marginLeft: theme.spacing(5),
  color: theme.colours.baseMid,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

export const AdvisorBox = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  textAlign: 'left',
  padding: `0 ${theme.spacing(.1)}`,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: 'hidden',
  display: 'block',
  alignSelf: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

export const TargetPropertyBox = styled("div")(({ theme }) => ({
  marginLeft: theme.spacing(5),
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  textAlign: 'left',
  padding: `0 ${theme.spacing(.1)}`,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: 'hidden',
  display: 'block',
  alignSelf: 'center',
  gridColumn: 'span 3',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))
